import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { setup_api } from './api/common'
import store from './store'
import vuetify from './plugins/vuetify'
import frappe_mix from './mixins/frappe-mixin'

Vue.config.productionTip = false

Vue.mixin(frappe_mix)

Vue.use(require('vue-moment'))

setup_api()
.finally(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})